import { render, staticRenderFns } from "./ContactTypeView.vue?vue&type=template&id=19573cd3"
import script from "./ContactTypeView.vue?vue&type=script&lang=js"
export * from "./ContactTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports